module.exports = __webpack_public_path__ + "img/Perks-Gift-25.8399b204.png";